import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPath = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.97333 3H3.83998C3.27211 3 2.81331 3.44687 2.81331 4V6C2.81331 6.55312 3.27211 7 3.83998 7H15.9483C16.083 7 16.2146 6.94688 16.3108 6.85313L17.8508 5.35313C18.0497 5.15938 18.0497 4.84062 17.8508 4.64687L16.3108 3.14688C16.2146 3.05313 16.083 3 15.9483 3H11.0267C11.0267 2.44687 10.5679 2 10 2C9.43212 2 8.97333 2.44687 8.97333 3ZM17.1867 10C17.1867 9.44688 16.7279 9 16.16 9H11.0267V8H8.97333V9H4.05173C3.91698 9 3.78544 9.05312 3.68919 9.14687L2.14919 10.6469C1.95027 10.8406 1.95027 11.1594 2.14919 11.3531L3.68919 12.8531C3.78544 12.9469 3.91698 13 4.05173 13H16.16C16.7279 13 17.1867 12.5531 17.1867 12V10ZM11.0267 17V14H8.97333V17C8.97333 17.5531 9.43212 18 10 18C10.5679 18 11.0267 17.5531 11.0267 17Z",
		fill: "#0D2976"
	})
});
export default SvgPath;
